import React, { Component, useEffect } from "react";
import { Image, Col, Row, FormCheck } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  Container,
  Header,
  Heading,
  Radio,
  RadioGroup,
  SelectPicker,
  InputNumber,
  Button,
  Input,
  DateInput,
  Text,
  Badge,
  Message,
  toaster,
  InputGroup,
  Modal,
  Card,
  IconButton,
} from "rsuite";
import "../Entities/style.css";
import { LuCopy } from "react-icons/lu";
import axios from "../axiosIn";
import { variables } from "../Variables";
import SearchIcon from "@rsuite/icons/Search";

export class Registro extends Component {
  constructor(props) {
    super(props);

    this.myRef = React.createRef();

    // SE REDIRIGE A HOME SE UTILIZA PARA EL CIERRE DEL REGISTRO
    // window.location.href = "/Home";

    const _window = window.location.href;
    let _param = [];
    _param = _window.split("=");
    let _esTutor = 0;

    if (_param.length > 1) {
      _esTutor = _param[2].trim();
    }

    this.state = {
      idLiga: 1,
      tipoInsc: "-1",
      tipoReg: "1",
      categoria: "",
      categorias: [{ label: "", value: "" }],
      tallas: [
        { label: "S - Chica", value: "S - Chica" },
        { label: "M - Mediana", value: "M - Mediana" },
        { label: "L - Grande", value: "L - Grande" },
        { label: "Extra grande", value: "XL - Extra Grande" },
        { label: "Doble Ex Grande", value: "XXL - Doble Ex Gde." },
      ],
      dataRegistro: [
        { label: "--SELECCIONA--", value: "-1" },
        { label: "Maratón 80 kms (UCMEX)", value: "1" },
        { label: "Medio Maratón 40 kms (Promocionales)", value: "0" },
      ],
      formaPagos: [
        {
          label: "Transferencia electrónica de fondos",
          value: "03 - Transferencia electrónica de fondos",
        },
      ],
      dataTipoSangre: [
        { label: "O-", value: "O-" },
        { label: "O+", value: "O+" },
        { label: "A-", value: "A-" },
        { label: "A+", value: "A+" },
        { label: "B-", value: "B-" },
        { label: "B+", value: "B+" },
        { label: "AB-", value: "AB-" },
        { label: "AB+", value: "AB+" },
      ],
      isMobile: window.innerWidth <= 768,
      correo: "",
      disabledReg: true,
      fileFoto: null,
      fileComprob: null,
      showCard1: "none",
      showCard2: "none",
      errNombre: "",
      errEquipo: "",
      errFecNac: "",
      errCurp: "",
      errCorreo: "",
      errTipoInsc: "",
      errProc: "",
      errCelular: "",
      errContactoEmergencia: "",
      errForma: "",
      errCategoria: "",
      errPlayera: "",
      errNumAfil: "",
      errComprob: "",
      errTipoSangre: "",
      errFoto: "",
      num: 1,
      numAfil: "",
      disTalla: true,
      precio: this.getCookie("precio"),
      resultCurpOk: "none",
      resultCurpErr: "none",
      showLabelPrice: "none",
      lblPrecio: "El precio por inscripción es de ",
      colorCurp: "#4caf50",
      msjValidacion: "",
      error: "",
      errTelefonoContacto: "",
      msjOk:
        "Se ha registrado, de forma correcta, en un momento se mostrará su carta responsiva...",
      displayMsjOk: "none",
      disabledOk: false,
      categoriaDisabled: true,
      disabledFoto: false,
      curpValidada: false,
      disabledComprob: false,
      curp: "",
      fecha: "",
      nombre: "",
      categoria: "",
      fecNac: "",
      clave: "",
      curp: "",
      equipo: "",
      tel: "",
      precio: "$ 0.00",
      contactoEmergencia: "",
      tipoSangre: "",
      procedencia: "",
      esTutor: _esTutor,
      telefonoContacto: "",
      tutor: "",
      optionsLista: [],
      listaBusq: [],
      openModal: false,
      filtro: "",
      mostrarBusqueda: false,
      talla: "",
    };
    this.getCierre();
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  focusInput = () => {
    this.myRef.current.focus();
  };

  async copiarValor(value) {
    await navigator.clipboard.writeText(value);
    this.toast("El valor se ha copiado.");
  }

  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  eventoClick() {
    console.log("");
  }

  getCierre = async () => {
    var url = `DatosCarrera/getCierre`;
    await axios
      .get(url)
      .then((res) => {
        if (res.data === 1) {
          window.location.href = "#/CierreEvento";
        }
      })
      .catch((err) => console.error(err));
  };

  getPrecios = async () => {
    var url = `Registro/GetPrecios`;
    await axios
      .get(url)
      .then((res) => {
        let arrayOpt = [];
        res.data.forEach((el) => {
          arrayOpt.push({
            descrip: el.descrip,
            value: el.value,
            precio: el.precio,
          });
        });
        this.setState({ optionsLista: arrayOpt });
      })
      .catch((err) => console.error(err));
  };

  async loadListaCategorias(tipoInsc) {
    var url = `Registro/ListaCategorias/${tipoInsc}`;
    await axios
      .get(url)
      .then((res) => {
        this.setState({ categorias: res.data });
      })
      .catch((err) => console.error(err));
  }

  isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.setState({ correo: email });
    if (!regex.test(email)) {
      this.setState({ errCorreo: "Formato de correo incorrecto!" });
      return "";
    } else {
      this.setState({ errCorreo: "" });
      return regex.test(email);
    }
  };

  async handlePrecio(e) {
    this.setCategorias(e);
    var url = `Registro/GetPrecio/${this.state.tipoInsc}`;
    await axios
      .get(url)
      .then((res) => {
        this.setState({ precio: res.data });
      })
      .catch((err) => console.error(err));
  }

  // componentDidMount() {
  //   this.loadListaCategorias(1);
  // }

  validEntity(values) {
    var tipoInsc = values.tipoInsc;
    var nombre = values.nombre;
    var equipo = values.equipo;
    var foto = values.foto;
    var _categoria = values.categoria;
    var fecNac = values.fecNac;
    var curp = values.curp;
    var celular = values.celular;
    var procedencia = values.procedencia;
    var contactoEmergencia = values.contactoEmergencia;
    var telefonoContacto = values.telefonoContacto;
    var tipoSangre = values.tipoSangre;
    var correo = values.correo;
    var _numAfil = values.numAfil;
    var _talla = values.talla;

    var errors = false;

    if (!nombre) {
      this.setState({ errNombre: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errNombre: "" });
    }

    if (!equipo) {
      this.setState({ errEquipo: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errEquipo: "" });
    }

    if (!_categoria) {
      this.setState({ errCategoria: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errCategoria: "" });
    }

    if (tipoInsc === "1" && !_numAfil) {
      this.setState({ errNumAfil: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errNumAfil: "" });
    }

    if (tipoInsc === "1" && !_talla) {
      this.setState({ errPlayera: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errPlayera: "" });
    }

    if (!fecNac) {
      this.setState({ errFecNac: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errFecNac: "" });
    }

    if (!curp) {
      this.setState({ errCurp: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errCurp: "" });
    }

    if(tipoInsc === "-1"){
      this.setState({ errTipoInsc: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errTipoInsc: "" });
    }

    if (!procedencia) {
      this.setState({ errProc: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errProc: "" });
    }

    if (!celular) {
      this.setState({ errCelular: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errCelular: "" });
    }

    if (!correo) {
      this.setState({ errCorreo: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errCorreo: "" });
    }

    if (!contactoEmergencia) {
      this.setState({ errContactoEmergencia: "* Obligatorio" });
    } else {
      this.setState({ errContactoEmergencia: "" });
    }

    if (!telefonoContacto) {
      this.setState({ errTelefonoContacto: "* Obligatorio" });
      errors = true;
    } else {
      this.setState({ errTelefonoContacto: "" });
    }

    if (!tipoSangre) {
      this.setState({ errTipoSangre: "* Obligatorio" });
    } else {
      this.setState({ errTipoSangre: "" });
    }

    if (!this.state.edadValida) {
      this.setState({
        errCategoria: "* Categoría incorrecta de acuerdo a edad",
      });
      errors = true;
    } else {
      this.setState({ errCategoria: "" });
    }

    return errors;
  }

  async saveEntity(values) {
    var _comprob = values.comprobante;
    var foto = values.foto;
    var _formPago = values.formaPago;
    var _validate = this.validEntity(values);

    console.log("Validate::: ", _validate);
    if (_validate) {
      this.setState({ disabledOk: false });
      return;
    }

    if (!_formPago) {
      this.setState({ errForma: "Debe seleccionar una forma de pago" });
      this.setState({ disabledOk: false });
      return;
    } else {
      this.setState({ errForma: "" });
    }

    if (
      _formPago !== "01 - Efectivo" &&
      this.state.fileComprob === null &&
      this.state.tipoInsc !== "4"
    ) {
      this.setState({ errComprob: "Debe adjuntar el pago" });
      this.setState({ disabledOk: false });
      return;
    } else {
      this.setState({ errComprob: "" });
    }

    if (!this.state.disabledFoto && foto.size === 0) {
      this.setState({ disabledOk: false });
      this.setState({ errFoto: "Debe adjuntar una fotografía" });
      return;
    }

    if (!this.state.curpValidada) {
      this.toast("El formato de la curp no es valido.", "error");
      this.setState({ disabledOk: false });
      return;
    }

    console.log("Grabando...");
    fetch(variables.API_URL + "Registro/SaveEntity", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nombre: values.nombre,
        equipo: values.equipo,
        categoria: values.categoria,
        curp: values.curp,
        fecNac: values.fecNac,
        formaPago: this.state.tipoInsc === "4" ? "Sin Pago" : values.formaPago,
        foto: !this.state.disabledFoto ? values.foto.name : "SinFoto.jpg",
        comprobante:
          this.state.fileComprob !== null ? this.state.fileComprob.name : "",
        celular: values.celular,
        procedencia: values.procedencia,
        contacto: values.contactoEmergencia,
        telContacto: values.telefonoContacto,
        tipoInsc: this.state.tipoInsc,
        tipoSangre: values.tipoSangre,
        talla: values.talla,
        responAceptada: 1,
        nombreTutor: this.state.tutor,
        correo: this.state.correo,
        afiliacion: this.state.numAfil,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result === -3) {
            this.toast("La CURP que intenta registrar, ya existe.", "warning");
            this.setState({ disabledOk: false });
            return;
          }
          if (result !== "") {
            console.log("Saved");
            this.saveFiles(result, values.formaPago);
          } else {
            this.setState({ disabledOk: false });
            alert("Valide la información, datos incompletos.");
          }
        },
        (error) => {
          this.setState({ disabledOk: false });
          alert("Ocurrio un error");
        },
      );
  }

  async calcularPrecio() {
    const abortController = new AbortController();
    var _idLiga = this.state.idLiga;
    var _tipoInsc = this.state.tipoInsc;
    var _tipoReg = this.state.tipoReg;
    var _num = this.state.num;

    var url = `Registro/GetFinalPrice/${_idLiga}/${_tipoInsc}/${_tipoReg}/${_num}`;

    try {
      const response = await axios.get(url, { signal: abortController.signal });
      this.setState({ showLabelPrice: "block" });
      this.setState({ precio: response.data.precioFin });
      var _precio = response.data.precioFinal;
      this.setState({ lblPrecio: `${response.data.msj}${_precio}` });
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        this.toast("Ha ocurrido un error", "error");
      }
    }
  }

  validaAniosCatego = async (idCatego) => {
    var url = `Registro/ValidaCategoFecNac/${idCatego}/${this.state.curp}`;

    await axios
      .get(url)
      .then((response) => {
        if (response.data.validacion === 0) {
          var edadMax = response.data.max;
          var msj = `La edad de esta categoría, se debe encontrar entre los ${response.data.min} y ${edadMax.toFixed(0)} años.`;
          if (edadMax === 0) {
            msj = `La edad inicial debe ser a partir de los ${response.data.min} años.`;
          }
          this.setState({ edadValida: false });
          this.toast(msj, "error");
        } else {
          this.setState({ edadValida: true });
          this.setState({ errCategoria: "" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleChange = (event) => {
    this.setState({ tipoReg: event });
    if (event === "2") {
      this.setState({ disabledReg: false });
    } else {
      this.setState({ disabledReg: true });
    }
  };

  handleChangeTipoInsc = (event) => {
    if (event === null || event === 0) {
      return;
    }

    this.loadListaCategorias(event);
    this.setState({ tipoInsc: event });
    this.setState({ showCard1: "none" });
    this.setState({ showCard2: "none" });
  };

  handleChangeNombre = (event) => {
    this.setState({ nombre: event.target.value });
  };

  handleFecNac = (date, event) => {
    this.setState({ fecNac: date });
  };

  clickComenzar = () => {
    if (this.state.esTutor === "1" && !this.state.tutor) {
      this.toast(
        "Debes escribir el nombre del padre o tutor, antes de continuar",
        "error",
      );
      return;
    }
    this.calcularPrecio();
    if (this.state.tipoInsc === "1") {
      this.setState({ showCard1: "block" });
      setTimeout(() => {
        this.focusInput();
      }, 300);
    } else {
      if (this.state.tipoInsc === "2") {
        this.setState({ disTalla: false });
      }
      this.setState({ showCard1: "block" });
      setTimeout(() => {
        this.focusInput();
      }, 300);
    }
    setTimeout(() => {
      this.focusInput();
    }, 300);
  };

  handleFileFoto = (e) => {
    this.setState({ fileFoto: e.target.files[0] });
  };

  handleFileComprob = (e) => {
    this.setState({ fileComprob: e.target.files[0] });
  };

  errorStyles = (errorVisible) => {
    return {
      display: errorVisible ? "block" : "none",
      color: "red",
      marginTop: 6,
    };
  };

  stringToDate(_date, _format, _delimiter) {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(
      dateItems[yearIndex],
      month,
      dateItems[dayIndex],
    );
    return formatedDate;
  }

  async getDataCurp() {
    const abortController = new AbortController();

    if (!this.state.curpValidada) {
      return;
    }

    var url = `Registro/GetHistoricData/${this.state.curp}`;
    this.setState({ loading: true });

    try {
      await axios
        .get(url, { signal: abortController.signal })
        .then((response) => {
          document.getElementById("foto").value = null;
          document.getElementById("comprobante").value = null;
          this.setState({ fecha: response.data.fecha });
          this.setState({ nombre: response.data.nombre });
          this.setState({ categoria: response.data.categoria });
          this.setState({ equipo: response.data.equipo });
          this.setState({ clave: response.data.clave });
          this.setState({ procedencia: response.data.procedencia });
          this.setState({ tel: response.data.tel });

          this.validaAniosCatego(response.data.clave);

          if (this.state.tipoInsc !== "3") {
            this.setState({ categoriaDisabled: true });
          } else {
            this.setState({ categoriaDisabled: false });
          }
          var _fecNac = this.stringToDate(
            response.data.fecNac,
            "dd/MM/yyyy",
            "/",
          );
          this.setState({ fecNac: _fecNac });
        })
        .catch((err) => {
          this.toast("La CURP no existe, en el padrón de registrados.");
          document.getElementById("foto").value = null;
          document.getElementById("comprobante").value = null;
          this.setState({ fecNac: null });
          this.setState({ nombre: "" });
          this.setState({ categoria: "" });
          this.setState({ equipo: "" });
          this.setState({ clave: "" });
          this.setState({ procedencia: "" });
          this.setState({ tel: "" });
          this.setState({ categoriaDisabled: false });
        });
    } catch (error) {
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        // Handle error
        this.toast("Ha ocurrido un error", "error");
      }
    }
  }

  curpValida = (curp) => {
    var re =
        /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/,
      validado = curp.match(re);

    this.setState({ resultCurpOk: "block" });

    if (!validado) {
      //Coincide con el formato general?
      this.setState({ msjValidacion: "Formato: Incorrecto" });
      document.getElementById("foto").value = null;
      document.getElementById("comprobante").value = null;
      this.setState({ curpValidada: false });
      this.setState({ colorCurp: "red" });
      this.setState({ fecNac: null });
      this.setState({ nombre: "" });
      this.setState({ categoria: "" });
      this.setState({ equipo: "" });
      this.setState({ clave: "" });
      this.setState({ procedencia: "" });
      this.setState({ tel: "" });
      return false;
    } else {
      this.setState({ msjValidacion: "Formato: Valido" });
      this.setState({ curpValidada: true });
      this.setState({ colorCurp: "#4caf50" });
    }

    //Validar que coincida el dígito verificador
    function digitoVerificador(curp17) {
      //Fuente https://consultas.curp.gob.mx/CurpSP/
      var diccionario = "0123456789ABCDEFGHIJKLMNÑOPQRSTUVWXYZ",
        lngSuma = 0.0,
        lngDigito = 0.0;
      for (var i = 0; i < 17; i++)
        lngSuma = lngSuma + diccionario.indexOf(curp17.charAt(i)) * (18 - i);
      lngDigito = 10 - (lngSuma % 10);
      if (lngDigito === 10) return 0;
      return lngDigito;
    }

    console.log("Validado TRUE");
    if (validado[2] !== digitoVerificador(validado[1])) return false;

    return true; //Validado
  };

  async saveFiles(curp, pago) {
    const formData = new FormData();
    formData.append("comprobante", this.state.fileComprob);
    formData.append("foto", this.state.fileFoto);
    formData.append("curp", curp);
    formData.append("forma", pago);

    await axios
      .post(variables.API_URL + "Registro/SaveFiles", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Saved files");
        this.setState({ displayMsjOk: "block" });
        setTimeout(() => {
          // window.location = `/#/Registro/Confirmado/curp=${curp}`;
          window.location.href = `/#/AceptaResponsiva/Registro/Confirmado/curp=${curp}`;
        }, 1500);
      });
  }

  async getBusqueda() {
    var url = `Registro/GetBusqueda/${this.state.filtro}`;

    await axios
      .get(variables.API_URL + url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        this.setState({ listaBusq: res.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    var data = new FormData(event.target);
    let formObject = Object.fromEntries(data.entries());

    this.setState({ disabledOk: true });
    this.saveEntity(formObject);
  };

  clikConFoto(event) {
    this.setState({ disabledFoto: !event.target.checked });
    if (!event.target.checked) {
      this.setState({ errFoto: "" });
    }
  }

  handleInputCurp = (e) => {
    var newValue = e.target.value.toUpperCase();
    this.setState({ curp: newValue });
  };

  toast(msg, type = "info") {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  }

  setNombre(value) {
    this.setState({ nombre: value });
  }

  setTutor(value) {
    this.setState({ tutor: value });
  }

  setCategorias(value) {
    this.setState({ clave: value });
    if (value != null) {
      this.validaAniosCatego(value);
    }
  }

  setFecNac(value) {
    this.setState({ fecNac: value });
  }

  setEquipo(value) {
    this.setState({ equipo: value });
  }

  setCelular(value) {
    this.setState({ tel: value });
  }

  setTelefonoContacto(value) {
    this.setState({ telefonoContacto: value });
  }

  setCorreo(value) {
    this.setState({ correo: value });
  }

  setContactoEmergencia(value) {
    this.setState({ contactoEmergencia: value });
  }

  setTipoSangre(value) {
    this.setState({ tipoSangre: value });
  }

  setProcedencia(value) {
    this.setState({ procedencia: value });
  }

  setFiltro(value) {
    this.setState({ filtro: value });
  }

  handleInput = (e) => {
    var newValue = e.toUpperCase();
    this.setState({ numAfil: newValue });
  };

  handleOpenModal(value) {
    this.setState({ openModal: value });
  }

  _handleKeyDown = (e) => {
    if (e.key === "F2") {
      this.setState({ listaBusq: [] });
      this.setState({ openModal: true });
    }
  };

  _handleEnter = (e) => {
    if (e.key === "Enter") {
      this.getBusqueda();
    }
  };

  selecRegistro(value) {
    this.setState({ curp: value });
    this.curpValida(value);
    this.handleOpenModal(false);
  }

  render() {
    const {
      pista,
      textoFecha,
      ubicacion,
      tipoInsc,
      tipoReg,
      disabledReg,
      disTalla,
      tallas,
      showCard1,
      fileComprob,
      fileFoto,
      formaPagos,
      categorias,
      dataRegistro,
      resultCurpOk,
      lblPrecio,
      showLabelPrice,
      num,
      numAfil,
      colorCurp,
      msjValidacion,
      talla,
      errNombre,
      errEquipo,
      errFecNac,
      errContactoEmergencia,
      errTipoSangre,
      errCurp,
      errProc,
      errTipoInsc,
      errCelular,
      errCorreo,
      errFoto,
      errForma,
      errCategoria,
      errPlayera,
      errNumAfil,
      precio,
      errComprob,
      contactoEmergencia,
      tipoSangre,
      msjOk,
      displayMsjOk,
      disabledOk,
      disabledFoto,
      curpValidada,
      disabledComprob,
      categoriaDisabled,
      curp,
      fecha,
      nombre,
      categoria,
      fecNac,
      clave,
      equipo,
      tel,
      procedencia,
      esTutor,
      tutor,
      filtro,
      isMobile,
      dataTipoSangre,
      mostrarBusqueda,
      openModal,
      optionsLista,
      listaBusq,
      correo,
      errTelefonoContacto,
      telefonoContacto,
    } = this.state;

    return (
      <>
        <div
          style={{
            backgroundImage: "url(Images/bikers.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "800px",
            minHeight: "100%",
            height: "auto",
            position: "fixed",
            top: 0,
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
        >
          <div className="App">
            <div style={{ padding: isMobile ? "20px" : "50px" }}>
              <Container>
                <Header
                  style={{
                    backgroundColor: "#f9f7f6",
                    padding: isMobile ? "20px" : "30px",
                    borderRadius: "15px",
                    opacity: 0.9,
                  }}
                >
                  <Row gutter={isMobile ? 20 : 30} align="middle">
                    <Col className="text-center col-lg-3 col-md-3 col-sm-3">
                      <Image
                        src={`Images/Logo1.jpg`}
                        height={isMobile ? "80px" : "100px"}
                      />
                    </Col>
                    <Col className="col-lg-6 col-md-6 col-sm-6">
                      <br></br>
                      <Text
                        size={isMobile ? "lg" : "4xl"}
                        style={{ fontWeight: 800 }}
                      >
                        Bienvenido(a) al registro del <br></br>
                        Maratón LiciVilla 2026
                      </Text>
                    </Col>
                    <Col className="text-center col-lg-3 col-md-3 col-sm-3">
                      <Image
                        src={`Images/UCMEX.png`}
                        height={isMobile ? "60px" : "100px"}
                      />
                    </Col>
                  </Row>
                </Header>
                <Card
                  bordered
                  style={{
                    padding: "20px",
                    oppacity: 0.9,
                    marginTop: "5px",
                    marginBottom: "5px",
                    textAlign: !this.state.isMobile ? "center" : "left",
                  }}
                >
                  {this.state.isMobile ? (
                    <Text size="lg" style={{ fontWeight: 400 }}>
                      <b>Datos para pago de inscripción</b> <br></br>
                      Banco HSBC<br></br>
                      Juan Manuel De Blas Ramírez
                      <IconButton
                        appearance="link"
                        style={{ fontSize: "18px" }}
                        icon={<LuCopy></LuCopy>}
                        onClick={() =>
                          this.copiarValor("Juan Manuel De Blas Ramírez")
                        }
                      ></IconButton>
                      <br></br>
                      <b>Tarjeta:</b> 4830 3045 0675 7339
                      <IconButton
                        appearance="link"
                        style={{ fontSize: "18px" }}
                        icon={<LuCopy></LuCopy>}
                        onClick={() => this.copiarValor("4830304506757339")}
                      ></IconButton>
                      <br></br>
                      <b>CLABE:</b> 021700 0645 3697 5461
                      <IconButton
                        appearance="link"
                        style={{ fontSize: "18px" }}
                        icon={<LuCopy></LuCopy>}
                        onClick={() => this.copiarValor("021700064536975461")}
                      ></IconButton>
                    </Text>
                  ) : (
                    <Text size="lg" style={{ fontWeight: 400 }}>
                      <b>Banco HSBC</b>, número de tarjeta:{" "}
                      <IconButton
                        appearance="link"
                        style={{ fontSize: "18px" }}
                        icon={<LuCopy></LuCopy>}
                        onClick={() => this.copiarValor("4830304506757339")}
                      ></IconButton>
                      4830 3045 0675 7339, Cuenta CLABE:{" "}
                      <IconButton
                        appearance="link"
                        style={{ fontSize: "18px" }}
                        icon={<LuCopy></LuCopy>}
                        onClick={() => this.copiarValor("021700064536975461")}
                      ></IconButton>
                      <b>021 700 0645 3697 5461</b>, a nombre de:{" "}
                      <IconButton
                        appearance="link"
                        style={{ fontSize: "18px" }}
                        icon={<LuCopy></LuCopy>}
                        onClick={() =>
                          this.copiarValor("Juan Manuel De Blas Ramírez")
                        }
                      ></IconButton>
                      <b>Juan Manuel De Blas Ramírez</b>
                    </Text>
                  )}
                </Card>
                <React.Fragment>
                  <form onSubmit={this.handleSubmit}>
                    <Container style={{ opacity: 0.96 }}>
                      <>
                        <div
                          className="card"
                          id="card1"
                          style={{ padding: "10px" }}
                        >
                          <div
                            className="card-body"
                            ref={this.myRef}
                            tabIndex={0}
                          >
                            <div className="row mb-3">
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>CURP</b>
                                <InputGroup>
                                  <Input
                                    placeholder="CURP"
                                    id="curp"
                                    name="curp"
                                    maxLength={18}
                                    onChange={this.curpValida}
                                    onInput={this.handleInputCurp}
                                    value={curp}
                                  />
                                  {mostrarBusqueda ? (
                                    <InputGroup.Button>
                                      <SearchIcon
                                        onClick={() =>
                                          this.handleOpenModal(true)
                                        }
                                      />
                                    </InputGroup.Button>
                                  ) : (
                                    ""
                                  )}
                                </InputGroup>
                                {errCurp && (
                                  <p style={{ color: "red" }}>{errCurp}</p>
                                )}
                                <Badge
                                  style={{
                                    background: `${colorCurp}`,
                                    color: "white",
                                    width: "100%",
                                    display: `${resultCurpOk}`,
                                  }}
                                >
                                  {msjValidacion}
                                </Badge>
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Nombre</b>
                                <Input
                                  placeholder="Nombre"
                                  name="nombre"
                                  id="nombre"
                                  value={this.state.nombre}
                                  onChange={(e) => this.setNombre(e)}
                                />
                                {errNombre && (
                                  <p style={{ color: "red" }}>{errNombre}</p>
                                )}
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Correo</b>
                                <Input
                                  id="correo"
                                  name="correo"
                                  placeholder="Correo electrónico..."
                                  value={this.state.correo}
                                  onChange={(e) => this.isValidEmail(e)}
                                />
                                {errCorreo && (
                                  <p style={{ color: "red" }}>{errCorreo}</p>
                                )}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Tipo de inscripción</b>
                                <SelectPicker
                                  id="tipoInsc"
                                  name="tipoInsc"
                                  disabled={!this.state.curpValidada}
                                  data={dataRegistro}
                                  value={tipoInsc}
                                  onChange={this.handleChangeTipoInsc}
                                  searchable={false}
                                  block
                                  placeholder="Selecciona"
                                />
                                {errTipoInsc && (
                                  <p style={{ color: "red" }}>{errTipoInsc}</p>
                                )}
                              </div>
                              {tipoInsc === "1" && (
                                <>
                                  <div className="col-lg-2 col-md-2 col-sm-2">
                                    <b>No. de Afiliación UCMEX</b>
                                    <Input
                                      placeholder="Número de afiliación"
                                      id="numAfil"
                                      name="numAfil"
                                      value={numAfil}
                                      onChange={(e) => this.handleInput(e)}
                                      maxLength={12}
                                    />
                                    {errNumAfil && (
                                      <p style={{ color: "red" }}>
                                        {errNumAfil}
                                      </p>
                                    )}
                                  </div>

                                  <div className="col-lg-2 col-md-2 col-sm-2">
                                    <b>Talla de playera</b>
                                    <SelectPicker
                                      id="talla"
                                      name="talla"
                                      data={tallas}
                                      value={this.state.talla}
                                      onChange={(e) =>
                                        this.setState({ talla: e })
                                      }
                                      searchable={false}
                                      block
                                      placeholder="SELECCIONA"
                                    />
                                    {errPlayera && (
                                      <p style={{ color: "red" }}>
                                        {errPlayera}
                                      </p>
                                    )}
                                  </div>
                                </>
                              )}
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Categoría</b>
                                <SelectPicker
                                  id="categoria"
                                  name="categoria"
                                  data={categorias}
                                  value={clave}
                                  onChange={(e) => this.handlePrecio(e)}
                                  searchable
                                  block
                                  placeholder="--SELECCIONA--"
                                />
                                {errCategoria && (
                                  <p style={{ color: "red" }}>{errCategoria}</p>
                                )}
                              </div>
                              <div className="col-lg-1 col-md-1 col-sm-1">
                                <b>Fec. Nac.</b>
                                <DateInput
                                  format="dd/MM/yyyy"
                                  id="fecNac"
                                  name="fecNac"
                                  value={this.state.fecNac}
                                  onChange={(e) => this.setFecNac(e)}
                                />
                                {errFecNac && (
                                  <p style={{ color: "red" }}>{errFecNac}</p>
                                )}
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Equipo</b>
                                <Input
                                  placeholder="Nombre del equipo"
                                  id="equipo"
                                  name="equipo"
                                  value={this.state.equipo}
                                  onChange={(e) => this.setEquipo(e)}
                                />
                                {errEquipo && (
                                  <p style={{ color: "red" }}>{errEquipo}</p>
                                )}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Procedencia</b>
                                <SelectPicker
                                  id="procedencia"
                                  name="procedencia"
                                  data={variables.ESTADOS}
                                  value={this.state.procedencia}
                                  onChange={(e) => this.setProcedencia(e)}
                                  searchable
                                  block
                                  placeholder="--SELECCIONA--"
                                />
                                {errProc && (
                                  <p style={{ color: "red" }}>{errProc}</p>
                                )}
                              </div>
                              <div className="text-center col-lg-1 col-md-1 col-sm-1">
                                <b>Precio</b>
                                <Input
                                  value={precio}
                                  readOnly
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "600",
                                    color: "blue",
                                  }}
                                />
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Adjuntar comprobante de pago</b>
                                <input
                                  type="file"
                                  id="comprobante"
                                  name="comprobante"
                                  accept=".jpg"
                                  onChange={this.handleFileComprob}
                                  disabled={disabledComprob}
                                />
                                <Text
                                  color="red"
                                  size="sm"
                                  style={{ display: `${showLabelPrice}` }}
                                >
                                  {lblPrecio}
                                </Text>
                                {errComprob && (
                                  <p style={{ color: "red" }}>{errComprob}</p>
                                )}
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <FormCheck
                                  type="checkbox"
                                  defaultChecked
                                  id="conFoto"
                                  label="Adjuntar foto"
                                  style={{ fontWeight: 800 }}
                                  onChange={(e) => this.clikConFoto(e)}
                                />
                                <input
                                  type="file"
                                  id="foto"
                                  name="foto"
                                  accept=".jpg"
                                  disabled={disabledFoto}
                                  onChange={this.handleFileFoto}
                                />
                                {errFoto && (
                                  <p style={{ color: "red" }}>{errFoto}</p>
                                )}
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Número de celular</b>
                                <Input
                                  id="celular"
                                  name="celular"
                                  placeholder="Celular"
                                  value={this.state.tel}
                                  onChange={(e) => this.setCelular(e)}
                                  maxLength={10}
                                />
                                {errCelular && (
                                  <p style={{ color: "red" }}>{errCelular}</p>
                                )}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Contacto de emergencia</b>
                                <Input
                                  id="contactoEmergencia"
                                  name="contactoEmergencia"
                                  placeholder="Contacto de emergencia"
                                  value={this.state.contactoEmergencia}
                                  onChange={(e) =>
                                    this.setContactoEmergencia(e)
                                  }
                                />
                                {errContactoEmergencia && (
                                  <p style={{ color: "red" }}>
                                    {errContactoEmergencia}
                                  </p>
                                )}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Teléfono de contacto</b>
                                <Input
                                  id="telefonoContacto"
                                  name="telefonoContacto"
                                  placeholder="Teléfono de contacto"
                                  value={this.state.telefonoContacto}
                                  maxLength={10}
                                  onChange={(e) => this.setTelefonoContacto(e)}
                                />
                                {errTelefonoContacto && (
                                  <p style={{ color: "red" }}>
                                    {errTelefonoContacto}
                                  </p>
                                )}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-2">
                                <b>Tipo de sangre</b>
                                <SelectPicker
                                  data={dataTipoSangre}
                                  id="tipoSangre"
                                  name="tipoSangre"
                                  block
                                  searchable={false}
                                  placeholder="--SELECCIONA--"
                                />
                                {errTipoSangre && (
                                  <p style={{ color: "red" }}>
                                    {errTipoSangre}
                                  </p>
                                )}
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-3">
                                <b>Forma de pago</b>
                                <SelectPicker
                                  data={formaPagos}
                                  id="formaPago"
                                  name="formaPago"
                                  block
                                  searchable={false}
                                  placeholder="--SELECCIONA--"
                                />
                                {errForma && (
                                  <p style={{ color: "red" }}>{errForma}</p>
                                )}
                              </div>
                              <div className="col-lg-1 col-md-1 col-sm-1">
                                <br></br>
                                <Button
                                  appearance="primary"
                                  color="green"
                                  style={{ width: "100%" }}
                                  type="submit"
                                  disabled={disabledOk}
                                >
                                  Enviar
                                </Button>
                              </div>
                            </div>
                            <div
                              className="row"
                              style={{ display: `${displayMsjOk}` }}
                            >
                              <div className="col">
                                <center>
                                  <Message showIcon type="info" centered>
                                    {msjOk}
                                  </Message>
                                </center>
                              </div>
                            </div>
                            <div className="row">
                              <div className="text-center col">
                                <Text color={"red"} size={"sm"}>
                                  * La información proporcionada será validada,
                                  en caso de no identificar el deposito o
                                  discrepancia en la información dada, nos
                                  comunicaremos contigo **
                                </Text>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </Container>
                  </form>
                </React.Fragment>
              </Container>
            </div>
          </div>
        </div>
      </>
    );
  }
}
